module.exports = __webpack_public_path__ + "media/packs/images/state/small/confirmed-cc1ef603da91f15511c31d79347ced02.svg";